var $8326b8a8079120b5$exports = {};
'use strict';
Object.defineProperty($8326b8a8079120b5$exports, '__esModule', {
    value: true
});
function $8326b8a8079120b5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8326b8a8079120b5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8326b8a8079120b5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8326b8a8079120b5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8326b8a8079120b5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8326b8a8079120b5$var$_extends() {
    $8326b8a8079120b5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8326b8a8079120b5$var$_extends.apply(this, arguments);
}
function $8326b8a8079120b5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8326b8a8079120b5$var$_setPrototypeOf(subClass, superClass);
}
function $8326b8a8079120b5$var$_getPrototypeOf(o) {
    $8326b8a8079120b5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8326b8a8079120b5$var$_getPrototypeOf(o);
}
function $8326b8a8079120b5$var$_setPrototypeOf(o, p) {
    $8326b8a8079120b5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8326b8a8079120b5$var$_setPrototypeOf(o, p);
}
function $8326b8a8079120b5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8326b8a8079120b5$var$_construct(Parent, args, Class) {
    if ($8326b8a8079120b5$var$_isNativeReflectConstruct()) $8326b8a8079120b5$var$_construct = Reflect.construct.bind();
    else $8326b8a8079120b5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8326b8a8079120b5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8326b8a8079120b5$var$_construct.apply(null, arguments);
}
function $8326b8a8079120b5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8326b8a8079120b5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8326b8a8079120b5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8326b8a8079120b5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8326b8a8079120b5$var$_construct(Class, arguments, $8326b8a8079120b5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8326b8a8079120b5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8326b8a8079120b5$var$_wrapNativeSuper(Class);
}
function $8326b8a8079120b5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8326b8a8079120b5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8326b8a8079120b5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8326b8a8079120b5$var$_arrayLikeToArray(o, minLen);
}
function $8326b8a8079120b5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8326b8a8079120b5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8326b8a8079120b5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8326b8a8079120b5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8326b8a8079120b5$var$_toPropertyKey(arg) {
    var key = $8326b8a8079120b5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $8326b8a8079120b5$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $8326b8a8079120b5$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $8326b8a8079120b5$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $8326b8a8079120b5$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $8326b8a8079120b5$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $8326b8a8079120b5$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $8326b8a8079120b5$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $8326b8a8079120b5$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $8326b8a8079120b5$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $8326b8a8079120b5$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $8326b8a8079120b5$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($8326b8a8079120b5$var$LuxonError);
/**
 * @private
 */ var $8326b8a8079120b5$var$n = "numeric", $8326b8a8079120b5$var$s = "short", $8326b8a8079120b5$var$l = "long";
var $8326b8a8079120b5$var$DATE_SHORT = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$n,
    day: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATE_MED = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$s,
    day: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATE_MED_WITH_WEEKDAY = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$s,
    day: $8326b8a8079120b5$var$n,
    weekday: $8326b8a8079120b5$var$s
};
var $8326b8a8079120b5$var$DATE_FULL = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$l,
    day: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATE_HUGE = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$l,
    day: $8326b8a8079120b5$var$n,
    weekday: $8326b8a8079120b5$var$l
};
var $8326b8a8079120b5$var$TIME_SIMPLE = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$TIME_WITH_SECONDS = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$TIME_WITH_SHORT_OFFSET = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    timeZoneName: $8326b8a8079120b5$var$s
};
var $8326b8a8079120b5$var$TIME_WITH_LONG_OFFSET = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    timeZoneName: $8326b8a8079120b5$var$l
};
var $8326b8a8079120b5$var$TIME_24_SIMPLE = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    hourCycle: "h23"
};
var $8326b8a8079120b5$var$TIME_24_WITH_SECONDS = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    hourCycle: "h23"
};
var $8326b8a8079120b5$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    hourCycle: "h23",
    timeZoneName: $8326b8a8079120b5$var$s
};
var $8326b8a8079120b5$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    hourCycle: "h23",
    timeZoneName: $8326b8a8079120b5$var$l
};
var $8326b8a8079120b5$var$DATETIME_SHORT = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$n,
    day: $8326b8a8079120b5$var$n,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$n,
    day: $8326b8a8079120b5$var$n,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATETIME_MED = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$s,
    day: $8326b8a8079120b5$var$n,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATETIME_MED_WITH_SECONDS = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$s,
    day: $8326b8a8079120b5$var$n,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$s,
    day: $8326b8a8079120b5$var$n,
    weekday: $8326b8a8079120b5$var$s,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n
};
var $8326b8a8079120b5$var$DATETIME_FULL = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$l,
    day: $8326b8a8079120b5$var$n,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    timeZoneName: $8326b8a8079120b5$var$s
};
var $8326b8a8079120b5$var$DATETIME_FULL_WITH_SECONDS = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$l,
    day: $8326b8a8079120b5$var$n,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    timeZoneName: $8326b8a8079120b5$var$s
};
var $8326b8a8079120b5$var$DATETIME_HUGE = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$l,
    day: $8326b8a8079120b5$var$n,
    weekday: $8326b8a8079120b5$var$l,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    timeZoneName: $8326b8a8079120b5$var$l
};
var $8326b8a8079120b5$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $8326b8a8079120b5$var$n,
    month: $8326b8a8079120b5$var$l,
    day: $8326b8a8079120b5$var$n,
    weekday: $8326b8a8079120b5$var$l,
    hour: $8326b8a8079120b5$var$n,
    minute: $8326b8a8079120b5$var$n,
    second: $8326b8a8079120b5$var$n,
    timeZoneName: $8326b8a8079120b5$var$l
};
/**
 * @interface
 */ var $8326b8a8079120b5$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
    };
    $8326b8a8079120b5$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $8326b8a8079120b5$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $8326b8a8079120b5$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $8326b8a8079120b5$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $8326b8a8079120b5$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $8326b8a8079120b5$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $8326b8a8079120b5$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $8326b8a8079120b5$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($8326b8a8079120b5$var$singleton$1 === null) $8326b8a8079120b5$var$singleton$1 = new SystemZone();
                return $8326b8a8079120b5$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($8326b8a8079120b5$var$Zone);
var $8326b8a8079120b5$var$dtfCache = new Map();
function $8326b8a8079120b5$var$makeDTF(zoneName) {
    var dtf = $8326b8a8079120b5$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $8326b8a8079120b5$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var $8326b8a8079120b5$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $8326b8a8079120b5$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $8326b8a8079120b5$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $8326b8a8079120b5$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$8326b8a8079120b5$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $8326b8a8079120b5$var$ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $8326b8a8079120b5$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $8326b8a8079120b5$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = $8326b8a8079120b5$var$ianaZoneCache.get(name);
        if (zone === undefined) $8326b8a8079120b5$var$ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    };
    IANAZone.resetCache = function resetCache() {
        $8326b8a8079120b5$var$ianaZoneCache.clear();
        $8326b8a8079120b5$var$dtfCache.clear();
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $8326b8a8079120b5$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $8326b8a8079120b5$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $8326b8a8079120b5$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $8326b8a8079120b5$var$partsOffset(dtf, date) : $8326b8a8079120b5$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $8326b8a8079120b5$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $8326b8a8079120b5$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($8326b8a8079120b5$var$Zone);
var $8326b8a8079120b5$var$_excluded = [
    "base"
], $8326b8a8079120b5$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $8326b8a8079120b5$var$intlLFCache = {};
function $8326b8a8079120b5$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $8326b8a8079120b5$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $8326b8a8079120b5$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $8326b8a8079120b5$var$intlDTCache = new Map();
function $8326b8a8079120b5$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $8326b8a8079120b5$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $8326b8a8079120b5$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
var $8326b8a8079120b5$var$intlNumCache = new Map();
function $8326b8a8079120b5$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $8326b8a8079120b5$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $8326b8a8079120b5$var$intlNumCache.set(key, inf);
    }
    return inf;
}
var $8326b8a8079120b5$var$intlRelCache = new Map();
function $8326b8a8079120b5$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $8326b8a8079120b5$var$_objectWithoutPropertiesLoose(_opts, $8326b8a8079120b5$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $8326b8a8079120b5$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $8326b8a8079120b5$var$intlRelCache.set(key, inf);
    }
    return inf;
}
var $8326b8a8079120b5$var$sysLocaleCache = null;
function $8326b8a8079120b5$var$systemLocale() {
    if ($8326b8a8079120b5$var$sysLocaleCache) return $8326b8a8079120b5$var$sysLocaleCache;
    else {
        $8326b8a8079120b5$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $8326b8a8079120b5$var$sysLocaleCache;
    }
}
var $8326b8a8079120b5$var$intlResolvedOptionsCache = new Map();
function $8326b8a8079120b5$var$getCachedIntResolvedOptions(locString) {
    var opts = $8326b8a8079120b5$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $8326b8a8079120b5$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var $8326b8a8079120b5$var$weekInfoCache = new Map();
function $8326b8a8079120b5$var$getCachedWeekInfo(locString) {
    var data = $8326b8a8079120b5$var$weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = $8326b8a8079120b5$var$_extends({}, $8326b8a8079120b5$var$fallbackWeekSettings, data);
        $8326b8a8079120b5$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $8326b8a8079120b5$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $8326b8a8079120b5$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $8326b8a8079120b5$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $8326b8a8079120b5$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $8326b8a8079120b5$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $8326b8a8079120b5$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $8326b8a8079120b5$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $8326b8a8079120b5$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $8326b8a8079120b5$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $8326b8a8079120b5$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $8326b8a8079120b5$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var $8326b8a8079120b5$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $8326b8a8079120b5$var$_objectWithoutPropertiesLoose(opts, $8326b8a8079120b5$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $8326b8a8079120b5$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $8326b8a8079120b5$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $8326b8a8079120b5$var$roundTo(i, 3);
            return $8326b8a8079120b5$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $8326b8a8079120b5$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $8326b8a8079120b5$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $8326b8a8079120b5$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $8326b8a8079120b5$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $8326b8a8079120b5$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $8326b8a8079120b5$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $8326b8a8079120b5$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $8326b8a8079120b5$var$hasRelative()) this.rtf = $8326b8a8079120b5$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $8326b8a8079120b5$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $8326b8a8079120b5$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $8326b8a8079120b5$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $8326b8a8079120b5$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $8326b8a8079120b5$var$systemLocale());
        var numberingSystemR = numberingSystem || $8326b8a8079120b5$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $8326b8a8079120b5$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $8326b8a8079120b5$var$validateWeekSettings(weekSettings) || $8326b8a8079120b5$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $8326b8a8079120b5$var$sysLocaleCache = null;
        $8326b8a8079120b5$var$intlDTCache.clear();
        $8326b8a8079120b5$var$intlNumCache.clear();
        $8326b8a8079120b5$var$intlRelCache.clear();
        $8326b8a8079120b5$var$intlResolvedOptionsCache.clear();
        $8326b8a8079120b5$var$weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $8326b8a8079120b5$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $8326b8a8079120b5$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $8326b8a8079120b5$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($8326b8a8079120b5$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($8326b8a8079120b5$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $8326b8a8079120b5$var$listStuff(this, length, $8326b8a8079120b5$var$months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = $8326b8a8079120b5$var$mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $8326b8a8079120b5$var$listStuff(this, length, $8326b8a8079120b5$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $8326b8a8079120b5$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $8326b8a8079120b5$var$listStuff(this, undefined, function() {
            return $8326b8a8079120b5$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $8326b8a8079120b5$var$DateTime.utc(2016, 11, 13, 9),
                    $8326b8a8079120b5$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $8326b8a8079120b5$var$listStuff(this, length, $8326b8a8079120b5$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $8326b8a8079120b5$var$DateTime.utc(-40, 1, 1),
                $8326b8a8079120b5$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $8326b8a8079120b5$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $8326b8a8079120b5$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $8326b8a8079120b5$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $8326b8a8079120b5$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $8326b8a8079120b5$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$8326b8a8079120b5$var$hasLocaleWeekInfo()) return $8326b8a8079120b5$var$fallbackWeekSettings;
        else return $8326b8a8079120b5$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $8326b8a8079120b5$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $8326b8a8079120b5$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $8326b8a8079120b5$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $8326b8a8079120b5$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $8326b8a8079120b5$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($8326b8a8079120b5$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $8326b8a8079120b5$var$formatOffset(this.fixed, format);
    };
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $8326b8a8079120b5$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $8326b8a8079120b5$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $8326b8a8079120b5$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($8326b8a8079120b5$var$singleton === null) $8326b8a8079120b5$var$singleton = new FixedOffsetZone(0);
                return $8326b8a8079120b5$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($8326b8a8079120b5$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $8326b8a8079120b5$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $8326b8a8079120b5$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $8326b8a8079120b5$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($8326b8a8079120b5$var$Zone);
/**
 * @private
 */ function $8326b8a8079120b5$var$normalizeZone(input, defaultZone) {
    if ($8326b8a8079120b5$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $8326b8a8079120b5$var$Zone) return input;
    else if ($8326b8a8079120b5$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $8326b8a8079120b5$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $8326b8a8079120b5$var$FixedOffsetZone.utcInstance;
        else return $8326b8a8079120b5$var$FixedOffsetZone.parseSpecifier(lowered) || $8326b8a8079120b5$var$IANAZone.create(input);
    } else if ($8326b8a8079120b5$var$isNumber(input)) return $8326b8a8079120b5$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $8326b8a8079120b5$var$InvalidZone(input);
}
var $8326b8a8079120b5$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $8326b8a8079120b5$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $8326b8a8079120b5$var$hanidecChars = $8326b8a8079120b5$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $8326b8a8079120b5$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($8326b8a8079120b5$var$numberingSystems.hanidec) !== -1) value += $8326b8a8079120b5$var$hanidecChars.indexOf(str[i]);
            else for(var key in $8326b8a8079120b5$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $8326b8a8079120b5$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $8326b8a8079120b5$var$digitRegexCache = new Map();
function $8326b8a8079120b5$var$resetDigitRegexCache() {
    $8326b8a8079120b5$var$digitRegexCache.clear();
}
function $8326b8a8079120b5$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = $8326b8a8079120b5$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $8326b8a8079120b5$var$digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + $8326b8a8079120b5$var$numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var $8326b8a8079120b5$var$now = function now() {
    return Date.now();
}, $8326b8a8079120b5$var$defaultZone = "system", $8326b8a8079120b5$var$defaultLocale = null, $8326b8a8079120b5$var$defaultNumberingSystem = null, $8326b8a8079120b5$var$defaultOutputCalendar = null, $8326b8a8079120b5$var$twoDigitCutoffYear = 60, $8326b8a8079120b5$var$throwOnInvalid, $8326b8a8079120b5$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $8326b8a8079120b5$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $8326b8a8079120b5$var$Locale.resetCache();
        $8326b8a8079120b5$var$IANAZone.resetCache();
        $8326b8a8079120b5$var$DateTime.resetCache();
        $8326b8a8079120b5$var$resetDigitRegexCache();
    };
    $8326b8a8079120b5$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $8326b8a8079120b5$var$now;
            },
            set: function set(n) {
                $8326b8a8079120b5$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $8326b8a8079120b5$var$normalizeZone($8326b8a8079120b5$var$defaultZone, $8326b8a8079120b5$var$SystemZone.instance);
            },
            set: function set(zone) {
                $8326b8a8079120b5$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $8326b8a8079120b5$var$defaultLocale;
            },
            set: function set(locale) {
                $8326b8a8079120b5$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $8326b8a8079120b5$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $8326b8a8079120b5$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $8326b8a8079120b5$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $8326b8a8079120b5$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $8326b8a8079120b5$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $8326b8a8079120b5$var$defaultWeekSettings = $8326b8a8079120b5$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $8326b8a8079120b5$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $8326b8a8079120b5$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $8326b8a8079120b5$var$throwOnInvalid;
            },
            set: function set(t) {
                $8326b8a8079120b5$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $8326b8a8079120b5$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $8326b8a8079120b5$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $8326b8a8079120b5$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $8326b8a8079120b5$var$unitOutOfRange(unit, value) {
    return new $8326b8a8079120b5$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $8326b8a8079120b5$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $8326b8a8079120b5$var$computeOrdinal(year, month, day) {
    return day + ($8326b8a8079120b5$var$isLeapYear(year) ? $8326b8a8079120b5$var$leapLadder : $8326b8a8079120b5$var$nonLeapLadder)[month - 1];
}
function $8326b8a8079120b5$var$uncomputeOrdinal(year, ordinal) {
    var table = $8326b8a8079120b5$var$isLeapYear(year) ? $8326b8a8079120b5$var$leapLadder : $8326b8a8079120b5$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $8326b8a8079120b5$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $8326b8a8079120b5$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $8326b8a8079120b5$var$computeOrdinal(year, month, day), weekday = $8326b8a8079120b5$var$isoWeekdayToLocal($8326b8a8079120b5$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $8326b8a8079120b5$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $8326b8a8079120b5$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $8326b8a8079120b5$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $8326b8a8079120b5$var$timeObject(gregObj));
}
function $8326b8a8079120b5$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $8326b8a8079120b5$var$isoWeekdayToLocal($8326b8a8079120b5$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $8326b8a8079120b5$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $8326b8a8079120b5$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $8326b8a8079120b5$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $8326b8a8079120b5$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $8326b8a8079120b5$var$_extends({
        year: year,
        month: month,
        day: day
    }, $8326b8a8079120b5$var$timeObject(weekData));
}
function $8326b8a8079120b5$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $8326b8a8079120b5$var$computeOrdinal(year, month, day);
    return $8326b8a8079120b5$var$_extends({
        year: year,
        ordinal: ordinal
    }, $8326b8a8079120b5$var$timeObject(gregData));
}
function $8326b8a8079120b5$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $8326b8a8079120b5$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $8326b8a8079120b5$var$_extends({
        year: year,
        month: month,
        day: day
    }, $8326b8a8079120b5$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $8326b8a8079120b5$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$8326b8a8079120b5$var$isUndefined(obj.localWeekday) || !$8326b8a8079120b5$var$isUndefined(obj.localWeekNumber) || !$8326b8a8079120b5$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$8326b8a8079120b5$var$isUndefined(obj.weekday) || !$8326b8a8079120b5$var$isUndefined(obj.weekNumber) || !$8326b8a8079120b5$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $8326b8a8079120b5$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$8326b8a8079120b5$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$8326b8a8079120b5$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$8326b8a8079120b5$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $8326b8a8079120b5$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $8326b8a8079120b5$var$isInteger(obj.weekYear), validWeek = $8326b8a8079120b5$var$integerBetween(obj.weekNumber, 1, $8326b8a8079120b5$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $8326b8a8079120b5$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $8326b8a8079120b5$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $8326b8a8079120b5$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $8326b8a8079120b5$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $8326b8a8079120b5$var$hasInvalidOrdinalData(obj) {
    var validYear = $8326b8a8079120b5$var$isInteger(obj.year), validOrdinal = $8326b8a8079120b5$var$integerBetween(obj.ordinal, 1, $8326b8a8079120b5$var$daysInYear(obj.year));
    if (!validYear) return $8326b8a8079120b5$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $8326b8a8079120b5$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $8326b8a8079120b5$var$hasInvalidGregorianData(obj) {
    var validYear = $8326b8a8079120b5$var$isInteger(obj.year), validMonth = $8326b8a8079120b5$var$integerBetween(obj.month, 1, 12), validDay = $8326b8a8079120b5$var$integerBetween(obj.day, 1, $8326b8a8079120b5$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $8326b8a8079120b5$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $8326b8a8079120b5$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $8326b8a8079120b5$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $8326b8a8079120b5$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $8326b8a8079120b5$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $8326b8a8079120b5$var$integerBetween(minute, 0, 59), validSecond = $8326b8a8079120b5$var$integerBetween(second, 0, 59), validMillisecond = $8326b8a8079120b5$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $8326b8a8079120b5$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $8326b8a8079120b5$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $8326b8a8079120b5$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $8326b8a8079120b5$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $8326b8a8079120b5$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $8326b8a8079120b5$var$isNumber(o) {
    return typeof o === "number";
}
function $8326b8a8079120b5$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $8326b8a8079120b5$var$isString(o) {
    return typeof o === "string";
}
function $8326b8a8079120b5$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $8326b8a8079120b5$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $8326b8a8079120b5$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $8326b8a8079120b5$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $8326b8a8079120b5$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $8326b8a8079120b5$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $8326b8a8079120b5$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $8326b8a8079120b5$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $8326b8a8079120b5$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$8326b8a8079120b5$var$integerBetween(settings.firstDay, 1, 7) || !$8326b8a8079120b5$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$8326b8a8079120b5$var$integerBetween(v, 1, 7);
        })) throw new $8326b8a8079120b5$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $8326b8a8079120b5$var$integerBetween(thing, bottom, top) {
    return $8326b8a8079120b5$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $8326b8a8079120b5$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $8326b8a8079120b5$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $8326b8a8079120b5$var$parseInteger(string) {
    if ($8326b8a8079120b5$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $8326b8a8079120b5$var$parseFloating(string) {
    if ($8326b8a8079120b5$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $8326b8a8079120b5$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($8326b8a8079120b5$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $8326b8a8079120b5$var$roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function $8326b8a8079120b5$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $8326b8a8079120b5$var$daysInYear(year) {
    return $8326b8a8079120b5$var$isLeapYear(year) ? 366 : 365;
}
function $8326b8a8079120b5$var$daysInMonth(year, month) {
    var modMonth = $8326b8a8079120b5$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $8326b8a8079120b5$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $8326b8a8079120b5$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $8326b8a8079120b5$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $8326b8a8079120b5$var$isoWeekdayToLocal($8326b8a8079120b5$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $8326b8a8079120b5$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $8326b8a8079120b5$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $8326b8a8079120b5$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($8326b8a8079120b5$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $8326b8a8079120b5$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $8326b8a8079120b5$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $8326b8a8079120b5$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $8326b8a8079120b5$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $8326b8a8079120b5$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $8326b8a8079120b5$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new $8326b8a8079120b5$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $8326b8a8079120b5$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($8326b8a8079120b5$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $8326b8a8079120b5$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $8326b8a8079120b5$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $8326b8a8079120b5$var$padStart(hours, 2) + ":" + $8326b8a8079120b5$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $8326b8a8079120b5$var$padStart(hours, 2) + $8326b8a8079120b5$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $8326b8a8079120b5$var$timeObject(obj) {
    return $8326b8a8079120b5$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $8326b8a8079120b5$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $8326b8a8079120b5$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $8326b8a8079120b5$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $8326b8a8079120b5$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($8326b8a8079120b5$var$monthsNarrow);
        case "short":
            return [].concat($8326b8a8079120b5$var$monthsShort);
        case "long":
            return [].concat($8326b8a8079120b5$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $8326b8a8079120b5$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $8326b8a8079120b5$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $8326b8a8079120b5$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $8326b8a8079120b5$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($8326b8a8079120b5$var$weekdaysNarrow);
        case "short":
            return [].concat($8326b8a8079120b5$var$weekdaysShort);
        case "long":
            return [].concat($8326b8a8079120b5$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $8326b8a8079120b5$var$meridiems = [
    "AM",
    "PM"
];
var $8326b8a8079120b5$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $8326b8a8079120b5$var$erasShort = [
    "BC",
    "AD"
];
var $8326b8a8079120b5$var$erasNarrow = [
    "B",
    "A"
];
function $8326b8a8079120b5$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($8326b8a8079120b5$var$erasNarrow);
        case "short":
            return [].concat($8326b8a8079120b5$var$erasShort);
        case "long":
            return [].concat($8326b8a8079120b5$var$erasLong);
        default:
            return null;
    }
}
function $8326b8a8079120b5$var$meridiemForDateTime(dt) {
    return $8326b8a8079120b5$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $8326b8a8079120b5$var$weekdayForDateTime(dt, length) {
    return $8326b8a8079120b5$var$weekdays(length)[dt.weekday - 1];
}
function $8326b8a8079120b5$var$monthForDateTime(dt, length) {
    return $8326b8a8079120b5$var$months(length)[dt.month - 1];
}
function $8326b8a8079120b5$var$eraForDateTime(dt, length) {
    return $8326b8a8079120b5$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $8326b8a8079120b5$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $8326b8a8079120b5$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $8326b8a8079120b5$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $8326b8a8079120b5$var$_macroTokenToFormatOpts = {
    D: $8326b8a8079120b5$var$DATE_SHORT,
    DD: $8326b8a8079120b5$var$DATE_MED,
    DDD: $8326b8a8079120b5$var$DATE_FULL,
    DDDD: $8326b8a8079120b5$var$DATE_HUGE,
    t: $8326b8a8079120b5$var$TIME_SIMPLE,
    tt: $8326b8a8079120b5$var$TIME_WITH_SECONDS,
    ttt: $8326b8a8079120b5$var$TIME_WITH_SHORT_OFFSET,
    tttt: $8326b8a8079120b5$var$TIME_WITH_LONG_OFFSET,
    T: $8326b8a8079120b5$var$TIME_24_SIMPLE,
    TT: $8326b8a8079120b5$var$TIME_24_WITH_SECONDS,
    TTT: $8326b8a8079120b5$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $8326b8a8079120b5$var$TIME_24_WITH_LONG_OFFSET,
    f: $8326b8a8079120b5$var$DATETIME_SHORT,
    ff: $8326b8a8079120b5$var$DATETIME_MED,
    fff: $8326b8a8079120b5$var$DATETIME_FULL,
    ffff: $8326b8a8079120b5$var$DATETIME_HUGE,
    F: $8326b8a8079120b5$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $8326b8a8079120b5$var$DATETIME_MED_WITH_SECONDS,
    FFF: $8326b8a8079120b5$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $8326b8a8079120b5$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $8326b8a8079120b5$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $8326b8a8079120b5$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $8326b8a8079120b5$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $8326b8a8079120b5$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $8326b8a8079120b5$var$padStart(n, p);
        var opts = $8326b8a8079120b5$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $8326b8a8079120b5$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $8326b8a8079120b5$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $8326b8a8079120b5$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $8326b8a8079120b5$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $8326b8a8079120b5$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return $8326b8a8079120b5$var$stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $8326b8a8079120b5$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $8326b8a8079120b5$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $8326b8a8079120b5$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $8326b8a8079120b5$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $8326b8a8079120b5$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $8326b8a8079120b5$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $8326b8a8079120b5$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $8326b8a8079120b5$var$offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var $8326b8a8079120b5$var$isoExtendedZone = "(?:" + $8326b8a8079120b5$var$offsetRegex.source + "?(?:\\[(" + $8326b8a8079120b5$var$ianaRegex.source + ")\\])?)?";
var $8326b8a8079120b5$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $8326b8a8079120b5$var$isoTimeRegex = RegExp("" + $8326b8a8079120b5$var$isoTimeBaseRegex.source + $8326b8a8079120b5$var$isoExtendedZone);
var $8326b8a8079120b5$var$isoTimeExtensionRegex = RegExp("(?:[Tt]" + $8326b8a8079120b5$var$isoTimeRegex.source + ")?");
var $8326b8a8079120b5$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $8326b8a8079120b5$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $8326b8a8079120b5$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $8326b8a8079120b5$var$extractISOWeekData = $8326b8a8079120b5$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $8326b8a8079120b5$var$extractISOOrdinalData = $8326b8a8079120b5$var$simpleParse("year", "ordinal");
var $8326b8a8079120b5$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $8326b8a8079120b5$var$sqlTimeRegex = RegExp($8326b8a8079120b5$var$isoTimeBaseRegex.source + " ?(?:" + $8326b8a8079120b5$var$offsetRegex.source + "|(" + $8326b8a8079120b5$var$ianaRegex.source + "))?");
var $8326b8a8079120b5$var$sqlTimeExtensionRegex = RegExp("(?: " + $8326b8a8079120b5$var$sqlTimeRegex.source + ")?");
function $8326b8a8079120b5$var$int(match, pos, fallback) {
    var m = match[pos];
    return $8326b8a8079120b5$var$isUndefined(m) ? fallback : $8326b8a8079120b5$var$parseInteger(m);
}
function $8326b8a8079120b5$var$extractISOYmd(match, cursor) {
    var item = {
        year: $8326b8a8079120b5$var$int(match, cursor),
        month: $8326b8a8079120b5$var$int(match, cursor + 1, 1),
        day: $8326b8a8079120b5$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $8326b8a8079120b5$var$extractISOTime(match, cursor) {
    var item = {
        hours: $8326b8a8079120b5$var$int(match, cursor, 0),
        minutes: $8326b8a8079120b5$var$int(match, cursor + 1, 0),
        seconds: $8326b8a8079120b5$var$int(match, cursor + 2, 0),
        milliseconds: $8326b8a8079120b5$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $8326b8a8079120b5$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $8326b8a8079120b5$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $8326b8a8079120b5$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $8326b8a8079120b5$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $8326b8a8079120b5$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $8326b8a8079120b5$var$isoTimeOnly = RegExp("^T?" + $8326b8a8079120b5$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $8326b8a8079120b5$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $8326b8a8079120b5$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($8326b8a8079120b5$var$parseFloating(yearStr)),
            months: maybeNegate($8326b8a8079120b5$var$parseFloating(monthStr)),
            weeks: maybeNegate($8326b8a8079120b5$var$parseFloating(weekStr)),
            days: maybeNegate($8326b8a8079120b5$var$parseFloating(dayStr)),
            hours: maybeNegate($8326b8a8079120b5$var$parseFloating(hourStr)),
            minutes: maybeNegate($8326b8a8079120b5$var$parseFloating(minuteStr)),
            seconds: maybeNegate($8326b8a8079120b5$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($8326b8a8079120b5$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $8326b8a8079120b5$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $8326b8a8079120b5$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $8326b8a8079120b5$var$untruncateYear($8326b8a8079120b5$var$parseInteger(yearStr)) : $8326b8a8079120b5$var$parseInteger(yearStr),
        month: $8326b8a8079120b5$var$monthsShort.indexOf(monthStr) + 1,
        day: $8326b8a8079120b5$var$parseInteger(dayStr),
        hour: $8326b8a8079120b5$var$parseInteger(hourStr),
        minute: $8326b8a8079120b5$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $8326b8a8079120b5$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $8326b8a8079120b5$var$weekdaysLong.indexOf(weekdayStr) + 1 : $8326b8a8079120b5$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $8326b8a8079120b5$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $8326b8a8079120b5$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $8326b8a8079120b5$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $8326b8a8079120b5$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $8326b8a8079120b5$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $8326b8a8079120b5$var$FixedOffsetZone(offset)
    ];
}
function $8326b8a8079120b5$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $8326b8a8079120b5$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $8326b8a8079120b5$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $8326b8a8079120b5$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $8326b8a8079120b5$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $8326b8a8079120b5$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $8326b8a8079120b5$var$FixedOffsetZone.utcInstance
    ];
}
function $8326b8a8079120b5$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $8326b8a8079120b5$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $8326b8a8079120b5$var$FixedOffsetZone.utcInstance
    ];
}
var $8326b8a8079120b5$var$isoYmdWithTimeExtensionRegex = $8326b8a8079120b5$var$combineRegexes($8326b8a8079120b5$var$isoYmdRegex, $8326b8a8079120b5$var$isoTimeExtensionRegex);
var $8326b8a8079120b5$var$isoWeekWithTimeExtensionRegex = $8326b8a8079120b5$var$combineRegexes($8326b8a8079120b5$var$isoWeekRegex, $8326b8a8079120b5$var$isoTimeExtensionRegex);
var $8326b8a8079120b5$var$isoOrdinalWithTimeExtensionRegex = $8326b8a8079120b5$var$combineRegexes($8326b8a8079120b5$var$isoOrdinalRegex, $8326b8a8079120b5$var$isoTimeExtensionRegex);
var $8326b8a8079120b5$var$isoTimeCombinedRegex = $8326b8a8079120b5$var$combineRegexes($8326b8a8079120b5$var$isoTimeRegex);
var $8326b8a8079120b5$var$extractISOYmdTimeAndOffset = $8326b8a8079120b5$var$combineExtractors($8326b8a8079120b5$var$extractISOYmd, $8326b8a8079120b5$var$extractISOTime, $8326b8a8079120b5$var$extractISOOffset, $8326b8a8079120b5$var$extractIANAZone);
var $8326b8a8079120b5$var$extractISOWeekTimeAndOffset = $8326b8a8079120b5$var$combineExtractors($8326b8a8079120b5$var$extractISOWeekData, $8326b8a8079120b5$var$extractISOTime, $8326b8a8079120b5$var$extractISOOffset, $8326b8a8079120b5$var$extractIANAZone);
var $8326b8a8079120b5$var$extractISOOrdinalDateAndTime = $8326b8a8079120b5$var$combineExtractors($8326b8a8079120b5$var$extractISOOrdinalData, $8326b8a8079120b5$var$extractISOTime, $8326b8a8079120b5$var$extractISOOffset, $8326b8a8079120b5$var$extractIANAZone);
var $8326b8a8079120b5$var$extractISOTimeAndOffset = $8326b8a8079120b5$var$combineExtractors($8326b8a8079120b5$var$extractISOTime, $8326b8a8079120b5$var$extractISOOffset, $8326b8a8079120b5$var$extractIANAZone);
/*
 * @private
 */ function $8326b8a8079120b5$var$parseISODate(s) {
    return $8326b8a8079120b5$var$parse(s, [
        $8326b8a8079120b5$var$isoYmdWithTimeExtensionRegex,
        $8326b8a8079120b5$var$extractISOYmdTimeAndOffset
    ], [
        $8326b8a8079120b5$var$isoWeekWithTimeExtensionRegex,
        $8326b8a8079120b5$var$extractISOWeekTimeAndOffset
    ], [
        $8326b8a8079120b5$var$isoOrdinalWithTimeExtensionRegex,
        $8326b8a8079120b5$var$extractISOOrdinalDateAndTime
    ], [
        $8326b8a8079120b5$var$isoTimeCombinedRegex,
        $8326b8a8079120b5$var$extractISOTimeAndOffset
    ]);
}
function $8326b8a8079120b5$var$parseRFC2822Date(s) {
    return $8326b8a8079120b5$var$parse($8326b8a8079120b5$var$preprocessRFC2822(s), [
        $8326b8a8079120b5$var$rfc2822,
        $8326b8a8079120b5$var$extractRFC2822
    ]);
}
function $8326b8a8079120b5$var$parseHTTPDate(s) {
    return $8326b8a8079120b5$var$parse(s, [
        $8326b8a8079120b5$var$rfc1123,
        $8326b8a8079120b5$var$extractRFC1123Or850
    ], [
        $8326b8a8079120b5$var$rfc850,
        $8326b8a8079120b5$var$extractRFC1123Or850
    ], [
        $8326b8a8079120b5$var$ascii,
        $8326b8a8079120b5$var$extractASCII
    ]);
}
function $8326b8a8079120b5$var$parseISODuration(s) {
    return $8326b8a8079120b5$var$parse(s, [
        $8326b8a8079120b5$var$isoDuration,
        $8326b8a8079120b5$var$extractISODuration
    ]);
}
var $8326b8a8079120b5$var$extractISOTimeOnly = $8326b8a8079120b5$var$combineExtractors($8326b8a8079120b5$var$extractISOTime);
function $8326b8a8079120b5$var$parseISOTimeOnly(s) {
    return $8326b8a8079120b5$var$parse(s, [
        $8326b8a8079120b5$var$isoTimeOnly,
        $8326b8a8079120b5$var$extractISOTimeOnly
    ]);
}
var $8326b8a8079120b5$var$sqlYmdWithTimeExtensionRegex = $8326b8a8079120b5$var$combineRegexes($8326b8a8079120b5$var$sqlYmdRegex, $8326b8a8079120b5$var$sqlTimeExtensionRegex);
var $8326b8a8079120b5$var$sqlTimeCombinedRegex = $8326b8a8079120b5$var$combineRegexes($8326b8a8079120b5$var$sqlTimeRegex);
var $8326b8a8079120b5$var$extractISOTimeOffsetAndIANAZone = $8326b8a8079120b5$var$combineExtractors($8326b8a8079120b5$var$extractISOTime, $8326b8a8079120b5$var$extractISOOffset, $8326b8a8079120b5$var$extractIANAZone);
function $8326b8a8079120b5$var$parseSQL(s) {
    return $8326b8a8079120b5$var$parse(s, [
        $8326b8a8079120b5$var$sqlYmdWithTimeExtensionRegex,
        $8326b8a8079120b5$var$extractISOYmdTimeAndOffset
    ], [
        $8326b8a8079120b5$var$sqlTimeCombinedRegex,
        $8326b8a8079120b5$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $8326b8a8079120b5$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $8326b8a8079120b5$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $8326b8a8079120b5$var$casualMatrix = $8326b8a8079120b5$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $8326b8a8079120b5$var$lowOrderMatrix), $8326b8a8079120b5$var$daysInYearAccurate = 365.2425, $8326b8a8079120b5$var$daysInMonthAccurate = 30.436875, $8326b8a8079120b5$var$accurateMatrix = $8326b8a8079120b5$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $8326b8a8079120b5$var$daysInYearAccurate / 7,
        days: $8326b8a8079120b5$var$daysInYearAccurate,
        hours: $8326b8a8079120b5$var$daysInYearAccurate * 24,
        minutes: $8326b8a8079120b5$var$daysInYearAccurate * 1440,
        seconds: $8326b8a8079120b5$var$daysInYearAccurate * 86400,
        milliseconds: $8326b8a8079120b5$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $8326b8a8079120b5$var$daysInYearAccurate / 28,
        days: $8326b8a8079120b5$var$daysInYearAccurate / 4,
        hours: $8326b8a8079120b5$var$daysInYearAccurate * 24 / 4,
        minutes: $8326b8a8079120b5$var$daysInYearAccurate * 1440 / 4,
        seconds: $8326b8a8079120b5$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $8326b8a8079120b5$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $8326b8a8079120b5$var$daysInMonthAccurate / 7,
        days: $8326b8a8079120b5$var$daysInMonthAccurate,
        hours: $8326b8a8079120b5$var$daysInMonthAccurate * 24,
        minutes: $8326b8a8079120b5$var$daysInMonthAccurate * 1440,
        seconds: $8326b8a8079120b5$var$daysInMonthAccurate * 86400,
        milliseconds: $8326b8a8079120b5$var$daysInMonthAccurate * 86400000
    }
}, $8326b8a8079120b5$var$lowOrderMatrix);
// units ordered by size
var $8326b8a8079120b5$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $8326b8a8079120b5$var$reverseUnits = $8326b8a8079120b5$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $8326b8a8079120b5$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $8326b8a8079120b5$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $8326b8a8079120b5$var$Duration(conf);
}
function $8326b8a8079120b5$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $8326b8a8079120b5$var$_createForOfIteratorHelperLoose($8326b8a8079120b5$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $8326b8a8079120b5$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $8326b8a8079120b5$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $8326b8a8079120b5$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$8326b8a8079120b5$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $8326b8a8079120b5$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$8326b8a8079120b5$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $8326b8a8079120b5$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $8326b8a8079120b5$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $8326b8a8079120b5$var$accurateMatrix : $8326b8a8079120b5$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $8326b8a8079120b5$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $8326b8a8079120b5$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $8326b8a8079120b5$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $8326b8a8079120b5$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($8326b8a8079120b5$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $8326b8a8079120b5$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $8326b8a8079120b5$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $8326b8a8079120b5$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $8326b8a8079120b5$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $8326b8a8079120b5$var$Invalid ? reason : new $8326b8a8079120b5$var$Invalid(reason, explanation);
        if ($8326b8a8079120b5$var$Settings.throwOnInvalid) throw new $8326b8a8079120b5$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $8326b8a8079120b5$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $8326b8a8079120b5$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $8326b8a8079120b5$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $8326b8a8079120b5$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $8326b8a8079120b5$var$INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = $8326b8a8079120b5$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($8326b8a8079120b5$var$isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter($8326b8a8079120b5$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($8326b8a8079120b5$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $8326b8a8079120b5$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $8326b8a8079120b5$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $8326b8a8079120b5$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $8326b8a8079120b5$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $8326b8a8079120b5$var$durationToMillis(this.matrix, this.values);
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $8326b8a8079120b5$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($8326b8a8079120b5$var$hasOwnProperty(dur.values, k) || $8326b8a8079120b5$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $8326b8a8079120b5$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $8326b8a8079120b5$var$asNumber(fn(this.values[k], k));
        }
        return $8326b8a8079120b5$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $8326b8a8079120b5$var$_extends({}, this.values, $8326b8a8079120b5$var$normalizeObject(values, Duration.normalizeUnit));
        return $8326b8a8079120b5$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $8326b8a8079120b5$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $8326b8a8079120b5$var$normalizeValues(this.matrix, vals);
        return $8326b8a8079120b5$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $8326b8a8079120b5$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $8326b8a8079120b5$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $8326b8a8079120b5$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($8326b8a8079120b5$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($8326b8a8079120b5$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $8326b8a8079120b5$var$normalizeValues(this.matrix, built);
        return $8326b8a8079120b5$var$clone$1(this, {
            values: built
        }, true);
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $8326b8a8079120b5$var$clone$1(this, {
            values: negated
        }, true);
    };
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = $8326b8a8079120b5$var$removeZeroes(this.values);
        return $8326b8a8079120b5$var$clone$1(this, {
            values: vals
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $8326b8a8079120b5$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $8326b8a8079120b5$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $8326b8a8079120b5$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $8326b8a8079120b5$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $8326b8a8079120b5$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $8326b8a8079120b5$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $8326b8a8079120b5$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $8326b8a8079120b5$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $8326b8a8079120b5$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $8326b8a8079120b5$var$Invalid ? reason : new $8326b8a8079120b5$var$Invalid(reason, explanation);
        if ($8326b8a8079120b5$var$Settings.throwOnInvalid) throw new $8326b8a8079120b5$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $8326b8a8079120b5$var$friendlyDateTime(start), builtEnd = $8326b8a8079120b5$var$friendlyDateTime(end);
        var validateError = $8326b8a8079120b5$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $8326b8a8079120b5$var$Duration.fromDurationLike(duration), dt = $8326b8a8079120b5$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $8326b8a8079120b5$var$Duration.fromDurationLike(duration), dt = $8326b8a8079120b5$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $8326b8a8079120b5$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $8326b8a8079120b5$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $8326b8a8079120b5$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $8326b8a8079120b5$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($8326b8a8079120b5$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $8326b8a8079120b5$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $8326b8a8079120b5$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $8326b8a8079120b5$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $8326b8a8079120b5$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $8326b8a8079120b5$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $8326b8a8079120b5$var$INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $8326b8a8079120b5$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $8326b8a8079120b5$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $8326b8a8079120b5$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $8326b8a8079120b5$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $8326b8a8079120b5$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $8326b8a8079120b5$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $8326b8a8079120b5$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $8326b8a8079120b5$var$Settings.defaultZone;
        var proto = $8326b8a8079120b5$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $8326b8a8079120b5$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $8326b8a8079120b5$var$normalizeZone(input, $8326b8a8079120b5$var$Settings.defaultZone);
    };
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale)).getStartOfWeek();
    };
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale)).getMinDaysInFirstWeek();
    };
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale)).getWeekendDays().slice();
    };
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $8326b8a8079120b5$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $8326b8a8079120b5$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $8326b8a8079120b5$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $8326b8a8079120b5$var$hasRelative(),
            localeWeek: $8326b8a8079120b5$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $8326b8a8079120b5$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($8326b8a8079120b5$var$Duration.fromMillis(ms).as("days"));
}
function $8326b8a8079120b5$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $8326b8a8079120b5$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $8326b8a8079120b5$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $8326b8a8079120b5$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $8326b8a8079120b5$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $8326b8a8079120b5$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $8326b8a8079120b5$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $8326b8a8079120b5$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $8326b8a8079120b5$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($8326b8a8079120b5$var$parseDigits(s));
        }
    };
}
var $8326b8a8079120b5$var$NBSP = String.fromCharCode(160);
var $8326b8a8079120b5$var$spaceOrNBSP = "[ " + $8326b8a8079120b5$var$NBSP + "]";
var $8326b8a8079120b5$var$spaceOrNBSPRegExp = new RegExp($8326b8a8079120b5$var$spaceOrNBSP, "g");
function $8326b8a8079120b5$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($8326b8a8079120b5$var$spaceOrNBSPRegExp, $8326b8a8079120b5$var$spaceOrNBSP);
}
function $8326b8a8079120b5$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($8326b8a8079120b5$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $8326b8a8079120b5$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($8326b8a8079120b5$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $8326b8a8079120b5$var$stripInsensitivities(s) === $8326b8a8079120b5$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $8326b8a8079120b5$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $8326b8a8079120b5$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $8326b8a8079120b5$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $8326b8a8079120b5$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $8326b8a8079120b5$var$unitForToken(token, loc) {
    var one = $8326b8a8079120b5$var$digitRegex(loc), two = $8326b8a8079120b5$var$digitRegex(loc, "{2}"), three = $8326b8a8079120b5$var$digitRegex(loc, "{3}"), four = $8326b8a8079120b5$var$digitRegex(loc, "{4}"), six = $8326b8a8079120b5$var$digitRegex(loc, "{6}"), oneOrTwo = $8326b8a8079120b5$var$digitRegex(loc, "{1,2}"), oneToThree = $8326b8a8079120b5$var$digitRegex(loc, "{1,3}"), oneToSix = $8326b8a8079120b5$var$digitRegex(loc, "{1,6}"), oneToNine = $8326b8a8079120b5$var$digitRegex(loc, "{1,9}"), twoToFour = $8326b8a8079120b5$var$digitRegex(loc, "{2,4}"), fourToSix = $8326b8a8079120b5$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($8326b8a8079120b5$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $8326b8a8079120b5$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $8326b8a8079120b5$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $8326b8a8079120b5$var$intUnit(oneToSix);
            case "yy":
                return $8326b8a8079120b5$var$intUnit(twoToFour, $8326b8a8079120b5$var$untruncateYear);
            case "yyyy":
                return $8326b8a8079120b5$var$intUnit(four);
            case "yyyyy":
                return $8326b8a8079120b5$var$intUnit(fourToSix);
            case "yyyyyy":
                return $8326b8a8079120b5$var$intUnit(six);
            // months
            case "M":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "MM":
                return $8326b8a8079120b5$var$intUnit(two);
            case "MMM":
                return $8326b8a8079120b5$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $8326b8a8079120b5$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "LL":
                return $8326b8a8079120b5$var$intUnit(two);
            case "LLL":
                return $8326b8a8079120b5$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $8326b8a8079120b5$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "dd":
                return $8326b8a8079120b5$var$intUnit(two);
            // ordinals
            case "o":
                return $8326b8a8079120b5$var$intUnit(oneToThree);
            case "ooo":
                return $8326b8a8079120b5$var$intUnit(three);
            // time
            case "HH":
                return $8326b8a8079120b5$var$intUnit(two);
            case "H":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "hh":
                return $8326b8a8079120b5$var$intUnit(two);
            case "h":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "mm":
                return $8326b8a8079120b5$var$intUnit(two);
            case "m":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "q":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "qq":
                return $8326b8a8079120b5$var$intUnit(two);
            case "s":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "ss":
                return $8326b8a8079120b5$var$intUnit(two);
            case "S":
                return $8326b8a8079120b5$var$intUnit(oneToThree);
            case "SSS":
                return $8326b8a8079120b5$var$intUnit(three);
            case "u":
                return $8326b8a8079120b5$var$simple(oneToNine);
            case "uu":
                return $8326b8a8079120b5$var$simple(oneOrTwo);
            case "uuu":
                return $8326b8a8079120b5$var$intUnit(one);
            // meridiem
            case "a":
                return $8326b8a8079120b5$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $8326b8a8079120b5$var$intUnit(four);
            case "kk":
                return $8326b8a8079120b5$var$intUnit(twoToFour, $8326b8a8079120b5$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $8326b8a8079120b5$var$intUnit(oneOrTwo);
            case "WW":
                return $8326b8a8079120b5$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $8326b8a8079120b5$var$intUnit(one);
            case "EEE":
                return $8326b8a8079120b5$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $8326b8a8079120b5$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $8326b8a8079120b5$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $8326b8a8079120b5$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $8326b8a8079120b5$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $8326b8a8079120b5$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $8326b8a8079120b5$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $8326b8a8079120b5$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $8326b8a8079120b5$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $8326b8a8079120b5$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $8326b8a8079120b5$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $8326b8a8079120b5$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $8326b8a8079120b5$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $8326b8a8079120b5$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($8326b8a8079120b5$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $8326b8a8079120b5$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$8326b8a8079120b5$var$isUndefined(matches.z)) zone = $8326b8a8079120b5$var$IANAZone.create(matches.z);
    if (!$8326b8a8079120b5$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $8326b8a8079120b5$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$8326b8a8079120b5$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$8326b8a8079120b5$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$8326b8a8079120b5$var$isUndefined(matches.u)) matches.S = $8326b8a8079120b5$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $8326b8a8079120b5$var$dummyDateTimeCache = null;
function $8326b8a8079120b5$var$getDummyDateTime() {
    if (!$8326b8a8079120b5$var$dummyDateTimeCache) $8326b8a8079120b5$var$dummyDateTimeCache = $8326b8a8079120b5$var$DateTime.fromMillis(1555555555555);
    return $8326b8a8079120b5$var$dummyDateTimeCache;
}
function $8326b8a8079120b5$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $8326b8a8079120b5$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $8326b8a8079120b5$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $8326b8a8079120b5$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $8326b8a8079120b5$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $8326b8a8079120b5$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $8326b8a8079120b5$var$expandMacroTokens($8326b8a8079120b5$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $8326b8a8079120b5$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $8326b8a8079120b5$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $8326b8a8079120b5$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $8326b8a8079120b5$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($8326b8a8079120b5$var$hasOwnProperty(matches, "a") && $8326b8a8079120b5$var$hasOwnProperty(matches, "H")) throw new $8326b8a8079120b5$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $8326b8a8079120b5$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $8326b8a8079120b5$var$explainFromTokens(locale, input, format) {
    var parser = new $8326b8a8079120b5$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $8326b8a8079120b5$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $8326b8a8079120b5$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $8326b8a8079120b5$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $8326b8a8079120b5$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($8326b8a8079120b5$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $8326b8a8079120b5$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $8326b8a8079120b5$var$INVALID = "Invalid DateTime";
var $8326b8a8079120b5$var$MAX_DATE = 8.64e15;
function $8326b8a8079120b5$var$unsupportedZone(zone) {
    return new $8326b8a8079120b5$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $8326b8a8079120b5$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $8326b8a8079120b5$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $8326b8a8079120b5$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $8326b8a8079120b5$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $8326b8a8079120b5$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $8326b8a8079120b5$var$DateTime($8326b8a8079120b5$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $8326b8a8079120b5$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $8326b8a8079120b5$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $8326b8a8079120b5$var$objToTS(obj, offset, zone) {
    return $8326b8a8079120b5$var$fixOffset($8326b8a8079120b5$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $8326b8a8079120b5$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $8326b8a8079120b5$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $8326b8a8079120b5$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $8326b8a8079120b5$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $8326b8a8079120b5$var$objToLocalTS(c);
    var _fixOffset = $8326b8a8079120b5$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $8326b8a8079120b5$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $8326b8a8079120b5$var$DateTime.fromObject(parsed, $8326b8a8079120b5$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $8326b8a8079120b5$var$DateTime.invalid(new $8326b8a8079120b5$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $8326b8a8079120b5$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $8326b8a8079120b5$var$Formatter.create($8326b8a8079120b5$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $8326b8a8079120b5$var$_toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $8326b8a8079120b5$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += $8326b8a8079120b5$var$padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += $8326b8a8079120b5$var$padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += $8326b8a8079120b5$var$padStart(o.c.day);
    return c;
}
function $8326b8a8079120b5$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += $8326b8a8079120b5$var$padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += $8326b8a8079120b5$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += $8326b8a8079120b5$var$padStart(o.c.second);
                }
            } else {
                c += $8326b8a8079120b5$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += $8326b8a8079120b5$var$padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += $8326b8a8079120b5$var$padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $8326b8a8079120b5$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $8326b8a8079120b5$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $8326b8a8079120b5$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $8326b8a8079120b5$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $8326b8a8079120b5$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $8326b8a8079120b5$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $8326b8a8079120b5$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $8326b8a8079120b5$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $8326b8a8079120b5$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $8326b8a8079120b5$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $8326b8a8079120b5$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $8326b8a8079120b5$var$InvalidUnitError(unit);
    return normalized;
}
function $8326b8a8079120b5$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $8326b8a8079120b5$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $8326b8a8079120b5$var$guessOffsetForZone(zone) {
    if ($8326b8a8079120b5$var$zoneOffsetTs === undefined) $8326b8a8079120b5$var$zoneOffsetTs = $8326b8a8079120b5$var$Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($8326b8a8079120b5$var$zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = $8326b8a8079120b5$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($8326b8a8079120b5$var$zoneOffsetTs);
        $8326b8a8079120b5$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $8326b8a8079120b5$var$quickDT(obj, opts) {
    var zone = $8326b8a8079120b5$var$normalizeZone(opts.zone, $8326b8a8079120b5$var$Settings.defaultZone);
    if (!zone.isValid) return $8326b8a8079120b5$var$DateTime.invalid($8326b8a8079120b5$var$unsupportedZone(zone));
    var loc = $8326b8a8079120b5$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$8326b8a8079120b5$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $8326b8a8079120b5$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($8326b8a8079120b5$var$isUndefined(obj[u])) obj[u] = $8326b8a8079120b5$var$defaultUnitValues[u];
        }
        var invalid = $8326b8a8079120b5$var$hasInvalidGregorianData(obj) || $8326b8a8079120b5$var$hasInvalidTimeData(obj);
        if (invalid) return $8326b8a8079120b5$var$DateTime.invalid(invalid);
        var offsetProvis = $8326b8a8079120b5$var$guessOffsetForZone(zone);
        var _objToTS = $8326b8a8079120b5$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $8326b8a8079120b5$var$Settings.now();
    return new $8326b8a8079120b5$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $8326b8a8079120b5$var$diffRelative(start, end, opts) {
    var round = $8326b8a8079120b5$var$isUndefined(opts.round) ? true : opts.round, rounding = $8326b8a8079120b5$var$isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = $8326b8a8079120b5$var$roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $8326b8a8079120b5$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $8326b8a8079120b5$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $8326b8a8079120b5$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $8326b8a8079120b5$var$zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $8326b8a8079120b5$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $8326b8a8079120b5$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $8326b8a8079120b5$var$Invalid("invalid input") : null) || (!zone.isValid ? $8326b8a8079120b5$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $8326b8a8079120b5$var$isUndefined(config.ts) ? $8326b8a8079120b5$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $8326b8a8079120b5$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $8326b8a8079120b5$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $8326b8a8079120b5$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $8326b8a8079120b5$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $8326b8a8079120b5$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $8326b8a8079120b5$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $8326b8a8079120b5$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $8326b8a8079120b5$var$FixedOffsetZone.utcInstance;
        return $8326b8a8079120b5$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $8326b8a8079120b5$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $8326b8a8079120b5$var$normalizeZone(options.zone, $8326b8a8079120b5$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($8326b8a8079120b5$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $8326b8a8079120b5$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$8326b8a8079120b5$var$isNumber(milliseconds)) throw new $8326b8a8079120b5$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$8326b8a8079120b5$var$MAX_DATE || milliseconds > $8326b8a8079120b5$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $8326b8a8079120b5$var$normalizeZone(options.zone, $8326b8a8079120b5$var$Settings.defaultZone),
            loc: $8326b8a8079120b5$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$8326b8a8079120b5$var$isNumber(seconds)) throw new $8326b8a8079120b5$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $8326b8a8079120b5$var$normalizeZone(options.zone, $8326b8a8079120b5$var$Settings.defaultZone),
            loc: $8326b8a8079120b5$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $8326b8a8079120b5$var$normalizeZone(opts.zone, $8326b8a8079120b5$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($8326b8a8079120b5$var$unsupportedZone(zoneToUse));
        var loc = $8326b8a8079120b5$var$Locale.fromObject(opts);
        var normalized = $8326b8a8079120b5$var$normalizeObject(obj, $8326b8a8079120b5$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $8326b8a8079120b5$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $8326b8a8079120b5$var$Settings.now(), offsetProvis = !$8326b8a8079120b5$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$8326b8a8079120b5$var$isUndefined(normalized.ordinal), containsGregorYear = !$8326b8a8079120b5$var$isUndefined(normalized.year), containsGregorMD = !$8326b8a8079120b5$var$isUndefined(normalized.month) || !$8326b8a8079120b5$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $8326b8a8079120b5$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $8326b8a8079120b5$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $8326b8a8079120b5$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $8326b8a8079120b5$var$orderedWeekUnits;
            defaultValues = $8326b8a8079120b5$var$defaultWeekUnitValues;
            objNow = $8326b8a8079120b5$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $8326b8a8079120b5$var$orderedOrdinalUnits;
            defaultValues = $8326b8a8079120b5$var$defaultOrdinalUnitValues;
            objNow = $8326b8a8079120b5$var$gregorianToOrdinal(objNow);
        } else {
            units = $8326b8a8079120b5$var$orderedUnits;
            defaultValues = $8326b8a8079120b5$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $8326b8a8079120b5$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$8326b8a8079120b5$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $8326b8a8079120b5$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $8326b8a8079120b5$var$hasInvalidOrdinalData(normalized) : $8326b8a8079120b5$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $8326b8a8079120b5$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $8326b8a8079120b5$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $8326b8a8079120b5$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $8326b8a8079120b5$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $8326b8a8079120b5$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $8326b8a8079120b5$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $8326b8a8079120b5$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $8326b8a8079120b5$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $8326b8a8079120b5$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $8326b8a8079120b5$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($8326b8a8079120b5$var$isUndefined(text) || $8326b8a8079120b5$var$isUndefined(fmt)) throw new $8326b8a8079120b5$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $8326b8a8079120b5$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $8326b8a8079120b5$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $8326b8a8079120b5$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $8326b8a8079120b5$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $8326b8a8079120b5$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $8326b8a8079120b5$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $8326b8a8079120b5$var$Invalid ? reason : new $8326b8a8079120b5$var$Invalid(reason, explanation);
        if ($8326b8a8079120b5$var$Settings.throwOnInvalid) throw new $8326b8a8079120b5$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $8326b8a8079120b5$var$formatOptsToTokens(formatOpts, $8326b8a8079120b5$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $8326b8a8079120b5$var$expandMacroTokens($8326b8a8079120b5$var$Formatter.parseFormat(fmt), $8326b8a8079120b5$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $8326b8a8079120b5$var$zoneOffsetTs = undefined;
        $8326b8a8079120b5$var$zoneOffsetGuessCache.clear();
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $8326b8a8079120b5$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $8326b8a8079120b5$var$tsToObj(ts1, o1);
        var c2 = $8326b8a8079120b5$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $8326b8a8079120b5$var$clone(this, {
                ts: ts1
            }),
            $8326b8a8079120b5$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $8326b8a8079120b5$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($8326b8a8079120b5$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($8326b8a8079120b5$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $8326b8a8079120b5$var$normalizeZone(zone, $8326b8a8079120b5$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($8326b8a8079120b5$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $8326b8a8079120b5$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $8326b8a8079120b5$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $8326b8a8079120b5$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $8326b8a8079120b5$var$normalizeObject(values, $8326b8a8079120b5$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $8326b8a8079120b5$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$8326b8a8079120b5$var$isUndefined(normalized.weekYear) || !$8326b8a8079120b5$var$isUndefined(normalized.weekNumber) || !$8326b8a8079120b5$var$isUndefined(normalized.weekday), containsOrdinal = !$8326b8a8079120b5$var$isUndefined(normalized.ordinal), containsGregorYear = !$8326b8a8079120b5$var$isUndefined(normalized.year), containsGregorMD = !$8326b8a8079120b5$var$isUndefined(normalized.month) || !$8326b8a8079120b5$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $8326b8a8079120b5$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $8326b8a8079120b5$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $8326b8a8079120b5$var$weekToGregorian($8326b8a8079120b5$var$_extends({}, $8326b8a8079120b5$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$8326b8a8079120b5$var$isUndefined(normalized.ordinal)) mixed = $8326b8a8079120b5$var$ordinalToGregorian($8326b8a8079120b5$var$_extends({}, $8326b8a8079120b5$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $8326b8a8079120b5$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($8326b8a8079120b5$var$isUndefined(normalized.day)) mixed.day = Math.min($8326b8a8079120b5$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $8326b8a8079120b5$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $8326b8a8079120b5$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $8326b8a8079120b5$var$Duration.fromDurationLike(duration);
        return $8326b8a8079120b5$var$clone(this, $8326b8a8079120b5$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $8326b8a8079120b5$var$Duration.fromDurationLike(duration).negate();
        return $8326b8a8079120b5$var$clone(this, $8326b8a8079120b5$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $8326b8a8079120b5$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $8326b8a8079120b5$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $8326b8a8079120b5$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $8326b8a8079120b5$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $8326b8a8079120b5$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $8326b8a8079120b5$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $8326b8a8079120b5$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = $8326b8a8079120b5$var$normalizeUnit(precision);
        var ext = format === "extended";
        var c = $8326b8a8079120b5$var$_toISODate(this, ext, precision);
        if ($8326b8a8079120b5$var$orderedUnits.indexOf(precision) >= 3) c += "T";
        c += $8326b8a8079120b5$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    };
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return $8326b8a8079120b5$var$_toISODate(this, format === "extended", $8326b8a8079120b5$var$normalizeUnit(precision));
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $8326b8a8079120b5$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = $8326b8a8079120b5$var$normalizeUnit(precision);
        var c = includePrefix && $8326b8a8079120b5$var$orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + $8326b8a8079120b5$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $8326b8a8079120b5$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $8326b8a8079120b5$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $8326b8a8079120b5$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $8326b8a8079120b5$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $8326b8a8079120b5$var$INVALID;
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $8326b8a8079120b5$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $8326b8a8079120b5$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $8326b8a8079120b5$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $8326b8a8079120b5$var$maybeArray(unit).map($8326b8a8079120b5$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $8326b8a8079120b5$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $8326b8a8079120b5$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $8326b8a8079120b5$var$diffRelative(base, this.plus(padding), $8326b8a8079120b5$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $8326b8a8079120b5$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $8326b8a8079120b5$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $8326b8a8079120b5$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $8326b8a8079120b5$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $8326b8a8079120b5$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $8326b8a8079120b5$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $8326b8a8079120b5$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $8326b8a8079120b5$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $8326b8a8079120b5$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $8326b8a8079120b5$var$TokenParser(localeToUse, fmt);
    };
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($8326b8a8079120b5$var$isUndefined(text) || $8326b8a8079120b5$var$isUndefined(formatParser)) throw new $8326b8a8079120b5$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $8326b8a8079120b5$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $8326b8a8079120b5$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $8326b8a8079120b5$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    };
    $8326b8a8079120b5$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $8326b8a8079120b5$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $8326b8a8079120b5$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $8326b8a8079120b5$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $8326b8a8079120b5$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $8326b8a8079120b5$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $8326b8a8079120b5$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $8326b8a8079120b5$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $8326b8a8079120b5$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $8326b8a8079120b5$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $8326b8a8079120b5$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $8326b8a8079120b5$var$friendlyDateTime(dateTimeish) {
    if ($8326b8a8079120b5$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $8326b8a8079120b5$var$isNumber(dateTimeish.valueOf())) return $8326b8a8079120b5$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $8326b8a8079120b5$var$DateTime.fromObject(dateTimeish);
    else throw new $8326b8a8079120b5$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $8326b8a8079120b5$var$VERSION = "3.7.2";
$8326b8a8079120b5$exports.DateTime = $8326b8a8079120b5$var$DateTime;
$8326b8a8079120b5$exports.Duration = $8326b8a8079120b5$var$Duration;
$8326b8a8079120b5$exports.FixedOffsetZone = $8326b8a8079120b5$var$FixedOffsetZone;
$8326b8a8079120b5$exports.IANAZone = $8326b8a8079120b5$var$IANAZone;
$8326b8a8079120b5$exports.Info = $8326b8a8079120b5$var$Info;
$8326b8a8079120b5$exports.Interval = $8326b8a8079120b5$var$Interval;
$8326b8a8079120b5$exports.InvalidZone = $8326b8a8079120b5$var$InvalidZone;
$8326b8a8079120b5$exports.Settings = $8326b8a8079120b5$var$Settings;
$8326b8a8079120b5$exports.SystemZone = $8326b8a8079120b5$var$SystemZone;
$8326b8a8079120b5$exports.VERSION = $8326b8a8079120b5$var$VERSION;
$8326b8a8079120b5$exports.Zone = $8326b8a8079120b5$var$Zone;


let $aa459f0fea9822fe$var$clockHasAppeared = false;
function $aa459f0fea9822fe$var$revealClock() {
    if ($aa459f0fea9822fe$var$clockHasAppeared) return;
    $aa459f0fea9822fe$var$clockHasAppeared = true;
    var clockIcon = document.getElementById('clockIcon');
    var clockFade = clockIcon.animate([
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ], {
        duration: 600,
        easing: 'ease',
        fill: 'forwards'
    });
    clockFade.finished.then(function() {
        clockIcon.style.opacity = '1';
        clockFade.cancel();
    });
}
function $aa459f0fea9822fe$var$numberWord(number, zero) {
    number = parseInt(number, 10);
    var map = {
        0: zero,
        1: 'one',
        2: 'two',
        3: 'three',
        4: 'four',
        5: 'five',
        6: 'six',
        7: 'seven',
        8: 'eight',
        9: 'nine',
        10: 'ten',
        11: 'eleven',
        12: 'twelve',
        13: 'thirteen',
        14: 'fourteen',
        15: 'fifteen',
        16: 'sixteen',
        17: 'seventeen',
        18: 'eighteen',
        19: 'nineteen'
    };
    var tenMap = {
        2: 'twenty',
        3: 'thirty',
        4: 'fourty',
        5: 'fifty',
        6: 'sixty',
        7: 'seventy',
        8: 'eighty',
        9: 'ninety'
    };
    if (number in map) return map[number];
    var digits = number.toString();
    var ones = $aa459f0fea9822fe$var$numberWord(digits[digits.length - 1], '');
    var tensDigit = parseInt(digits[digits.length - 2], 10);
    var output = tenMap[tensDigit] || '';
    if (ones) output += ' ' + ones;
    return output;
}
function $aa459f0fea9822fe$var$updateTime() {
    var now = (0, $8326b8a8079120b5$exports.DateTime).local().setZone('Pacific/Auckland');
    var hour = (parseFloat(window.timeRange.value) + now.hour + now.minute / 60 + now.second / 3600) % 24;
    var offset = parseFloat(window.timeRange.value);
    now = now.plus({
        hours: offset
    });
    // Update clock hands using CSS variables
    var hourAngle = now.hour % 12 * 30 + now.minute * 0.5 // 30 degrees per hour, 0.5 degrees per minute
    ;
    var minuteAngle = now.minute * 6 // 6 degrees per minute
    ;
    var secondAngle = now.second * 6 // 6 degrees per second
    ;
    // Set CSS variables on the clock icon
    var clockIcon = document.getElementById('clockIcon');
    clockIcon.style.setProperty('--hour-angle', hourAngle + 'deg');
    clockIcon.style.setProperty('--minute-angle', minuteAngle + 'deg');
    clockIcon.style.setProperty('--second-angle', secondAngle + 'deg');
    // Position the clock icon over the slider thumb
    var sliderRect = window.timeRange.getBoundingClientRect();
    var value = parseFloat(window.timeRange.value);
    var min = parseFloat(window.timeRange.min);
    var max = parseFloat(window.timeRange.max);
    var percent = (value - min) / (max - min);
    // Calculate thumb position (accounting for thumb width)
    var thumbWidth = 24;
    var trackWidth = sliderRect.width - thumbWidth;
    // Center clock on thumb (using larger clock size so it overlaps border)
    var thumbLeft = window.scrollX + sliderRect.left + trackWidth * percent + thumbWidth / 2 - 13;
    var thumbTop = window.scrollY + sliderRect.top + sliderRect.height / 2 - 13;
    clockIcon.style.left = thumbLeft + 'px';
    clockIcon.style.top = thumbTop + 'px';
    if ($aa459f0fea9822fe$var$clockHasAppeared) clockIcon.style.opacity = '1';
    if (offset === 0) window.time.innerHTML = "It's ";
    else {
        var formattedOffset = Math.abs(offset) + ' ' + (Math.abs(offset) === 1 ? 'hour' : 'hours');
        if (offset > 0) window.time.innerHTML = 'In ' + formattedOffset + " it'll be ";
        else window.time.innerHTML = formattedOffset + ' ago it was ';
    }
    var closestHour = now.plus({
        minutes: 30
    });
    if (closestHour.minute < 15) window.time.innerHTML += ' coming up to ';
    else if (closestHour.minute < 30) window.time.innerHTML += ' nearly ';
    else if (closestHour.minute < 45) window.time.innerHTML += ' just past ';
    else window.time.innerHTML += ' some time after ';
    window.time.innerHTML += '<strong title="' + now.toFormat('cccc, h:mm a') + '">' + closestHour.toFormat('ha').toLowerCase() + ' on ' + closestHour.toFormat('cccc') + '</strong>.';
    if (hour < 6) hour += 24;
    var absoluteHour = hour % 24;
    hour = hour - 6;
    var day = hour < 12;
    if (!day) hour = hour - 12;
    hour = hour / 12;
    var boxClass;
    if (absoluteHour >= 22 || absoluteHour < 6) boxClass = 'night';
    else if (absoluteHour >= 18) boxClass = 'evening';
    else if (absoluteHour >= 12) boxClass = 'afternoon';
    else boxClass = 'morning';
    window.box.className = boxClass;
    // window.time.innerHTML += '<br>' + parseInt(hour * 100, 10) + '% through ' + (day ? 'day' : 'night')
    window.sun.style.display = boxClass === 'morning' || boxClass === 'afternoon' ? 'block' : 'none';
    window.moon.style.display = boxClass === 'evening' || boxClass === 'night' ? 'block' : 'none';
    window.sun.style.top = parseInt(100 - hour * 100, 10) + '%';
    var base = Math.pow(hour, 2);
    var right = parseInt(base * 26, 10) + 3;
    window.sun.style.right = right + '%';
    window.moon.style.top = parseInt(100 - hour * 100, 10) + '%';
    window.moon.style.right = right + '%';
    // Ninja shadow calculation
    var mainEl = document.getElementById('main');
    var ninjaEl = document.getElementById('ninja');
    if (boxClass === 'morning' || boxClass === 'afternoon') {
        // Get ninja dimensions
        var ninjaWidth = ninjaEl.offsetWidth;
        var ninjaHeight = ninjaEl.offsetHeight;
        // Set ninja dimensions as CSS vars
        mainEl.style.setProperty('--ninja-width', ninjaWidth + 'px');
        mainEl.style.setProperty('--ninja-height', ninjaHeight + 'px');
        // Shadow scales from short at sunrise to longer at sunset (quadratic)
        var scaleY = 0.5 + Math.pow(hour, 2) * 1.0 // 0.5 at sunrise, 1.5 at sunset
        ;
        // Skew changes with time of day
        var skewDeg = 80 - 90 * hour // +80 at sunrise (hour=0), -10 at sunset (hour=1)
        ;
        // Get ninja's absolute position
        var ninjaRect = ninjaEl.getBoundingClientRect();
        // Shadow positioned at ninja's top-right corner
        var shadowTop = window.scrollY + ninjaRect.top;
        var shadowRight = window.innerWidth - ninjaRect.right;
        if (mainEl.classList.contains('work-profile')) shadowRight -= 15;
        // Shadow opacity - fade in from sunrise based on skew
        // When skew is very high (near 80), fade in
        var sunriseFade = Math.min(1, Math.max(0, (80 - skewDeg) / 18));
        var shadowOpacity = 0.06 * sunriseFade;
        mainEl.style.setProperty('--ninja-shadow-top', shadowTop + 'px');
        mainEl.style.setProperty('--ninja-shadow-right', shadowRight + 'px');
        mainEl.style.setProperty('--ninja-shadow-skew', skewDeg + 'deg');
        mainEl.style.setProperty('--ninja-shadow-scaleY', scaleY);
        mainEl.style.setProperty('--ninja-shadow-opacity', shadowOpacity);
        // Enable transitions after first render (position is calculated)
        if (!mainEl.classList.contains('shadow-ready')) requestAnimationFrame(function() {
            mainEl.classList.add('shadow-ready');
        });
    } else // Hide shadow during evening/night
    mainEl.style.setProperty('--ninja-shadow-opacity', '0');
}
window.timeRange.addEventListener('input', $aa459f0fea9822fe$var$updateTime);
window.addEventListener('resize', function() {
    window.clockIcon.style.transition = 'none';
    window.clockIcon.getBoundingClientRect();
    window.clockIcon.style.opacity = '0';
    requestAnimationFrame(function() {
        window.clockIcon.style.transition = '';
    });
});
function $aa459f0fea9822fe$var$doUpdateTime() {
    $aa459f0fea9822fe$var$updateTime();
    setTimeout($aa459f0fea9822fe$var$doUpdateTime, 1000) // Update every second for the second hand
    ;
}
window.timeRange.style.display = '';
$aa459f0fea9822fe$var$doUpdateTime();
requestAnimationFrame($aa459f0fea9822fe$var$revealClock);
var $aa459f0fea9822fe$var$dateWords = document.querySelectorAll('.year-word');
for(var $aa459f0fea9822fe$var$i = 0; $aa459f0fea9822fe$var$i < $aa459f0fea9822fe$var$dateWords.length; $aa459f0fea9822fe$var$i++){
    var $aa459f0fea9822fe$var$el = $aa459f0fea9822fe$var$dateWords[$aa459f0fea9822fe$var$i];
    var $aa459f0fea9822fe$var$year = (0, $8326b8a8079120b5$exports.DateTime).local().setZone('Pacific/Auckland').diff((0, $8326b8a8079120b5$exports.DateTime).fromISO($aa459f0fea9822fe$var$el.getAttribute('data-date')), 'years').years;
    $aa459f0fea9822fe$var$el.innerText = $aa459f0fea9822fe$var$numberWord($aa459f0fea9822fe$var$year, 'zero');
}
// On the work profile, keep the white introduction fixed while clipping it
// against the scrolling edge of the sky. The grey copy beneath is revealed.
var $aa459f0fea9822fe$var$fixedIntroduction = document.querySelector('.fixed-introduction');
if ($aa459f0fea9822fe$var$fixedIntroduction) {
    var $aa459f0fea9822fe$var$skyIntroduction = document.querySelector('#box h1');
    var $aa459f0fea9822fe$var$fixedRole = document.querySelector('.fixed-role');
    var $aa459f0fea9822fe$var$introRole = document.querySelector('.intro strong');
    var $aa459f0fea9822fe$var$compactFooter = document.querySelector('.compact-profile-footer');
    function updateIntroductionClip() {
        var skyBottom = window.box.getBoundingClientRect().bottom;
        $aa459f0fea9822fe$var$compactFooter.classList.toggle('is-visible', skyBottom <= 0);
        var introductionBottom = $aa459f0fea9822fe$var$skyIntroduction.getBoundingClientRect().bottom;
        var clipBottom = Math.max(0, introductionBottom - skyBottom);
        $aa459f0fea9822fe$var$skyIntroduction.style.setProperty('--sky-heading-clip', clipBottom + 'px');
        var roleRect = $aa459f0fea9822fe$var$introRole.getBoundingClientRect();
        var roleProgress = Math.min(1, Math.max(0, (32 - roleRect.top) / (roleRect.height + 32)));
        $aa459f0fea9822fe$var$fixedRole.style.setProperty('--fixed-role-opacity', roleProgress);
    }
    window.addEventListener('scroll', updateIntroductionClip, {
        passive: true
    });
    window.addEventListener('resize', updateIntroductionClip);
    updateIntroductionClip();
}


//# sourceMappingURL=repo.34268318.js.map
